import { createUseStyles } from 'react-jss';
import CloseIcon from '../../../assets/images/cross.svg';
import SuccessPopupIcon from '../../../assets/images/successPopupIcon.svg';
import FailurePopupIcon from '../../../assets/images/failurePopupIcon.svg';
import ButtonV2 from '../../atoms/ButtonV2';

interface ButtonProps {
    text: string,
    variant: CustomVariant,
    size: CustomSize,
    onClick: () => void,
}

interface SuccessFailurePopupProps {
    width?: string,
    height?: string,
    status: boolean,
    heading: string,
    setShowPopup: (value: boolean) => void,
    button1?: ButtonProps,
    button2?: ButtonProps,
    description?: string,
}

type CustomVariant = "primaryContained" | "secondaryContained" | "tertiaryContained" | "primaryText" | "secondaryText" | "contained"| 'underlined' | "tertiaryText";
type CustomSize = "small" | "medium" | "large";

const useStyles = createUseStyles((theme: any) => ({
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        background: `${theme.palette.background.primaryLightAccent}80`,
        zIndex: 99,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    primaryContainer: {
        width: "458px",
        background: theme.palette.buttonV2.primaryContained.text.primaryLight,
        boxShadow: `0px 5px 16px 0px ${theme.palette.backgroundV2.failure.failure1000}40`,
        zIndex: 1,
    },
    description: {
        color: theme.palette.backgroundV2.tertiary.tertiary600,
        marginTop: "12px",
        fontSize: "14px"
    },
    btn: {
        columnGap: "16px",
        marginTop: "32px",
        marginBottom: "48px"
    },
    heading: {
        fontSize: "36px",
        paddingTop: "24px"
    },
    "@media (max-width: 480px)": {
        primaryContainer: {
            width: "280px",
        },
        description: {
            marginTop: "8px",
            fontSize: "12px"
        },
        btn: {
            columnGap: "12px",
            marginTop: "24px",
            marginBottom: "32px"
        },
        heading: {
            fontSize: "24px",
            lineHeight: "30px"
        },
    },
}))

const SuccessFailurePopup: React.FC<SuccessFailurePopupProps> = ({
    width,
    height,
    status,
    heading,
    setShowPopup,
    button1,
    button2,
    description,
}) => {

    const classes = useStyles();

    const divStyle = {
        height,
        width,
    };

    const handleClose = () => {
        setShowPopup(false);
    }

    return (
        <div className={classes.overlay}>
            <div className={`${classes.primaryContainer} rounded-3xl relative overflow-hidden`} style={divStyle}>
                <img src={CloseIcon} alt="icon" className='absolute right-6 top-6 w-6 h-6 cursor-pointer' onClick={handleClose} />
                <div className="flex flex-col items-center">
                    <>
                        <img src={status ? SuccessPopupIcon : FailurePopupIcon} alt="img" className="" />
                        <span className={status ? `${classes.heading} !text-emerald-600 text-4xl font-semibold ` : `${classes.heading} !text-red-600 text-4xl font-semibold`}>{heading}</span>
                        <p className={`${classes.description} font-normal`}>{description}</p>
                    </>

                    <div className={`${classes.btn} flex w-4/5 justify-center`}>
                        {button1 && <ButtonV2
                        className='!px-4'
                            variant={button1.variant}
                            label={button1.text}
                            size={button1.size}
                            onClick={button1.onClick}
                        />}
                        {button2 && <ButtonV2
                          className='!px-4'
                            variant={button2.variant}
                            label={button2.text}
                            size={button2.size}
                            onClick={button2.onClick}
                        />}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SuccessFailurePopup;